module.exports = __webpack_public_path__ + "static/media/aadhaar.0cd85a07.png";